import { inject, injectable } from "inversify";
import { ISessionService } from "services/SessionService";
import { SERVICE_TYPES } from "setup/dependency/ServiceTypes";

/* eslint @typescript-eslint/no-explicit-any: 0 */
@injectable()
export class CPLAuthClientBase {
  @inject(SERVICE_TYPES.SessionService) sessionService!: ISessionService;

  protected async transformOptions(options: RequestInit, anonymousRequest: boolean = false) {
    options.headers = {
      ...options.headers,
      ...(!anonymousRequest && { Authorization: `Bearer ${await this.sessionService.getCPLSessionToken()}` }),
      Timeout: "300",
    };
    return await Promise.resolve(options);
  }

  protected transformResult(url: string, response: Response, processor: (response: Response) => any) {
    // TODO: Return own result or throw exception to change default processing behavior,
    // or call processor function to run the default processing logic

    console.log("Service call: " + url);
    return processor(response);
  }

  protected getBaseUrl(defaultUrl: string, baseUrl?: string): string {
    if (baseUrl) {
      return baseUrl;
    }

    return process.env.REACT_APP_CPL_AUTH_API_BASE_URI as string;
  }
}
